module.exports = __webpack_public_path__ + "static/media/flash_chat.22f5b6ea.gif";